import { apolloClient } from '@/apollo'
import gql from 'graphql-tag'
import Vue from 'vue'

export const getOrganizationContact = gql`
query getOrganizationContact($id: uuid!) {
  organization_contact(where: {organization_id: {_eq: $id}}) {
    contact_type
    email
    id
    last_name
    name
    phone
    role
  }
}
`

export const createOrganizationContact = gql`
mutation createOrganizationContact($created_at: timestamptz!, $email: String!, $last_name: String!, $name: String!, $organization_id: uuid!, $phone: String!, $role: String!, $contact_type: String!) {
  insert_organization_contact_one(object: {created_at: $created_at, email: $email, last_name: $last_name, name: $name, organization_id: $organization_id, phone: $phone, role: $role, contact_type: $contact_type}) {
    id
  }
}
`

export const updateOrganizationContact = gql`
mutation updateOrganizationContact($id: uuid!, $contact_type: String!, $email: String!, $last_name: String!, $name: String!, $phone: String!, $role: String!, $updated_at: timestamptz!) {
  update_organization_contact_by_pk(pk_columns: {id: $id}, _set: {contact_type: $contact_type, email: $email, last_name: $last_name, name: $name, phone: $phone, role: $role, updated_at: $updated_at}) {
    id
  }
}
`

export const deleteOrganizationContact = gql`
mutation deleteOrganizationContact($id: uuid!) {
  delete_organization_contact_by_pk(id: $id) {
    id
  }
}
`

const organizationContact = {
  namespaced: true,
  state: {
    organizationContact: []
  },
  actions: {
    async getOrganizationContact ({ state }, id) {
      try {
        const requestQuery = {
          fetchPolicy: 'network-only',
          query: getOrganizationContact,
          variables: {
            id
          }
        }
        const response = await apolloClient.query(requestQuery)
        if (response && response.data && response.data.organization_contact.length) {
          Vue.set(state, 'organizationContact', response.data.organization_contact)
          return response.data.organization_contact
        }
        return null
      } catch (error) {
        throw new Error(error)
      }
    },
    async createOrganizationContact ({ commit }, variables) {
      try {
        const updateMutation = {
          mutation: createOrganizationContact,
          variables
        }
        const result = await apolloClient.mutate(updateMutation)
        if (result && result.data) {
          return result.data.insert_organization_contact_one
        }
        return result
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateOrganizationContact ({ commit }, variables) {
      try {
        const updateMutation = {
          mutation: updateOrganizationContact,
          variables
        }
        const result = await apolloClient.mutate(updateMutation)
        if (result && result.data) {
          return result.data.update_organization_contact_by_pk
        }
        return result
      } catch (error) {
        throw new Error(error)
      }
    },
    async deleteOrganizationContact ({ commit }, variables) {
      try {
        const updateMutation = {
          mutation: deleteOrganizationContact,
          variables
        }
        const result = await apolloClient.mutate(updateMutation)
        if (result && result.data) {
          return result.data.delete_organization_contact_by_pk
        }
        return result
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}

export default organizationContact



// WEBPACK FOOTER //
// ./src/store/modules/organizationContact.js